
import qs from 'query-string';
import React from 'react';
import { ButtonGroup, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { ArcaField } from '../../code/ArcaField';
import { ArcaHttpClientPerson } from '../../code/ArcaHttpClientPerson';
import { ArcaHttpClientPet } from '../../code/ArcaHttpClientPet';
import { ArcaHttpClientQuestions } from '../../code/ArcaHttpClientQuestions';
import { ArcaHttpSystem } from '../../code/ArcaHttpSystem';
import { ArcaPageFieldState } from '../../code/ArcaPageFieldState';
import { ArcaRedirect } from '../../code/ArcaRedirect';
import { ArcaSecurity } from '../../code/ArcaSecurity';
import { ArcaPet } from '../../code/Types/ArcaPet';
import { ArcaLink } from '../controls/Fields/ArcaLink';
import { InputField } from '../controls/Fields/InputField';
import { TermsAndConditions } from '../controls/Security/TermsAndConditions';
import { StatusBar } from '../controls/StatusBar';
import { ArcaComponent } from './ArcaComponent';

export class PetEdit extends ArcaComponent {

    constructor(props) {
        super(props);
        const values = qs.parse(this.props.location.search);

        // New pet
        var pet = new ArcaPet();
        pet.OwnerId = values.personid;

        var formState = new ArcaPageFieldState();
        this.state = {
            isLoading: true,
            formState: formState,
            petId: values.id,
            personId: values.personid,
            pet: pet,
            questions: null,

            isSaved: false,
            disabled: true,
            isError: false,
            statusText: null,
            petExists: true,
            savePopupOpen: false,
            activeTab: 'Details',
            saveConfirmButtonVisible: false,
            formValid: false,
            dataChanged: false,
            dataWasSaved: false
        };
    }

    async componentDidMount() {

        if (this.state.petId !== undefined) {
            // Existing pet

            await ArcaHttpClientPet.GetAsync(
                this.state.petId,
                (
                    (pet) => {
                        this.state.pet = pet;
                        this.getTheQuestionsAsync(pet.Code)
                    }));
        }
        else {
            // new pet

            await ArcaHttpClientPerson.GetAsync(
                this.state.personId,
                (person => {

                    let pet = new ArcaPet();
                    pet.OwnerId = this.state.personId
                    pet.Code = 'Dog'
                    pet.IsActive = 1
                    pet.AddressLine1 = person.AddressLine1;

                    this.state.pet = pet;
                    this.getTheQuestionsAsync(pet.Code)
                })
            )



        }
    }

    componentWillUnmount() {
        if (this.state.formState.HasChanged && !this.state.dataWasSaved)// && confirm('save changed data?'))
            this.updateData()
    }

    async getTheQuestionsAsync(petType) {

        await ArcaHttpClientQuestions.GetByFormAsync(
            (petType === 'Dog' ? 'DogDetails' : 'PetDetails'),
            ((questions) => {
                this.state.questions = questions;
                let { pet } = this.state
                var formState = this.buildFields();

                this.setState({
                    formState: formState,
                    pet: pet,
                    isLoading: false,
                });


            }),
            (txt) => this.setState({ isError: true, statusText: txt })
        );
    }

    async updateData() {
        try {
            var response;
            let { pet } = this.state;

            if (pet.Id === 0) {
                response = await ArcaHttpClientPet.AddAsync(pet);
            }
            else {
                response = await ArcaHttpClientPet.UpdateAsync(pet);
            }

            switch (response.status) {
                case 200:
                    {
                        var petId = await response.json();
                        pet.Id = petId;
                        this.state.dataWasSaved = true;
                        ArcaRedirect.Push('/PersonView/?id=' + this.state.personId)
                        break;
                    }

                case 400:
                    {
                        const message = await response.json();

                        this.setState({
                            isError: true,
                            statusText: message,
                            disabled: true,
                        });
                        break;
                    }
                default:
                    break;
            }
        }
        catch (error) {
            this.setState({
                isError: true,
                statusText: 'error',
                disabled: true,
            });
        }
    }

    render() {
        let { savePopupOpen, saveConfirmButtonVisible, personId, pet, statusText, isError, petId, formState } = this.state;
        let onSaveCancel = () => this.setState({ savePopupOpen: false })
        let onSaveConfirm = () => {
            ArcaHttpSystem.Log('onSaveConfirm')
            this.updateData();
            this.setState({ savePopupOpen: false });
        }

        return (
            <div>

                {this.state.isLoading
                    ? (<p><em>Loading...</em></p>)
                    : (
                        <div>
                            <h1 className='centerText' id="tabelLabel">{pet.FullName}</h1>

                            <dev className='centeredText'>
                                <ButtonGroup className='buttonGroup'>
                                    <ArcaLink
                                        colour='primary'
                                        text='Owner'
                                        disabled={formState.HasChanged}
                                        link={'/PersonView/?id=' + personId} />

                                    <ArcaLink
                                        text='Save changes'
                                        colour='secondary'
                                        width='180px'
                                        onClick={() => this.setState({ savePopupOpen: true })}
                                        disabled = {!formState.IsValid || !formState.HasChanged} />

                                </ButtonGroup>
                            </dev>

                            <StatusBar isError={isError} message={statusText} />

                            {this.state.formState.Fields.map((f, k) =>
                                <InputField
                                    label={f.FieldLabel}
                                    fieldname={f.FieldName}
                                    key={f.FieldName}
                                    regularExpression={f.Validation}
                                    warnText='Invalid format'
                                    fieldType={f.FieldType}
                                    mandatory={f.IsMandatory}
                                    value={f.Value}
                                    onUpdate={this.onUpdate.bind(this)}
                                    fieldValid={f.IsValid}
                                    prependWidth={'200px'}
                                    description={f.Description}
                                />

                            )}

                            <ArcaLink
                                text='Save changes'
                                colour='secondary'
                                width='180px'
                                onClick={() => this.setState({ savePopupOpen: true })}
                                disabled={!formState.IsValid} />


                            {savePopupOpen
                                ? <Modal isOpen={true}>
                                    <ModalHeader toggle={onSaveCancel}>
                                        Updating your pet`s details
                                    </ModalHeader>
                                    <ModalBody>
                                        <p>Please read and confirms the terms and condition before saving.</p>
                                        {(petId !== 0 && petId !== undefined)
                                            ? <strong>
                                                <br />
                                                <input type='checkbox' value='ConfirmHappy' onClick={() => this.setState({ saveConfirmButtonVisible: !saveConfirmButtonVisible })} />
                                                <label htmlFor='ConfirmHappy'>Confirm you are happy with the terms</label>
                                            </strong>
                                            : <strong>Please click on this link to our terms and conditions and scroll through to confirm you have read them before saving.</strong>
                                        }
                                        <br />
                                        <br />
                                        <TermsAndConditions isVisible={false} showText={true} onConfirm={() => this.setState({ saveConfirmButtonVisible: true })} />

                                    </ModalBody>
                                    <ModalFooter>
                                        <p></p>
                                        <p> When saving pet details, please be aware that what you have declared  has a bearing on our terms and details.</p>
                                        <ArcaLink disabled={!saveConfirmButtonVisible} colour="primary" onClick={onSaveConfirm} text='Confirm' />
                                        <ArcaLink colour="secondary" onClick={onSaveCancel} text='Cancel' />
                                    </ModalFooter>
                                </Modal>
                                : null}

                        </div >
                    )
                }
            </div>
        );
    }

    async onUpdate(value, isValid, fieldName) {

        let { pet, formState } = this.state

        var field = formState.GetField(fieldName);
        field.IsValid = isValid;

        var lastValue = field.Value;
        field.Value = value;

        if (pet.Answers[fieldName] !== undefined)
            pet.Answers[fieldName] = value;
        else
            pet[fieldName] = value;

        if (fieldName === 'Code' && lastValue !== value) {
            await this.getTheQuestionsAsync(value);
            return;
        }

        this.setState({
            pet: pet,
            disabled: false,
            formValid: formState.IsValid,
            dataChanged: true
        });
    }

    buildFields() {
        let { questions, pet } = this.state;

        var formState = new ArcaPageFieldState();

        if (ArcaSecurity.IsAdmin || ArcaSecurity.IsWalker)
            formState.AddField(new ArcaField("Arca Notes", "ArcaNotes", pet.ArcaNotes, true, false, 'textarea'));

        formState.AddField(new ArcaField("Pet's name", "FullName", pet.FullName, true, true, 'text', 'name'));
        formState.AddField(new ArcaField("First line of address", "AddressLine1", pet.AddressLine1, pet.AddressLine1 !== '', true, 'text', 'address'));
        formState.AddField(new ArcaField("Type of pet", "Code", pet.Code, true, true, 'select', 'PetType'));
        formState.AddField(new ArcaField("Preferred Activity", "Activity", pet.Activity, true, false, 'select', 'ActivityType'));
        formState.AddField(new ArcaField("Breed", "Breed", pet.Breed, true, false, 'text'));

        questions.map((q, k) => {
            if (pet.Answers[q.Code] === undefined)
                pet.Answers[q.Code] = '';

            formState.AddField(new ArcaField(q.Label, q.Code, pet.Answers[q.Code], true, q.Mandatory, q.Type, q.Validation, q.Text))
            return;
        });

        return formState;
    }
}
